import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

export interface ChatSession {
    conversation_id: string;
    title?: string;
}

interface ChatSessionListProps {
    chatSessions: ChatSession[];
    activeSessionId: string | null;
    onSwitchSession: (id: string) => void;
    onRenameSession: (id: string) => void;
    onDeleteSession: (id: string) => void;
}

const ChatSessionList: React.FC<ChatSessionListProps> = ({
    chatSessions,
    activeSessionId,
    onSwitchSession,
    onRenameSession,
    onDeleteSession,
}) => {
    const navigate = useNavigate();
    const renderChatRow = (session: ChatSession) => {
        const isActive = session.conversation_id === activeSessionId;
        return (
            <div
                key={session.conversation_id}
                className={`chat-session ${isActive ? "active" : ""}`}
                onClick={() => {
                    onSwitchSession(session.conversation_id);
                    navigate(`/chat/${session.conversation_id}`);
                }}
            >
                <span className="session-title">{session.title || "Untitled Chat"}</span>
                <div className="session-actions">
                    <Button
                        icon="pi pi-pencil"
                        className="p-button-text p-button-sm"
                        onClick={(e) => { e.stopPropagation(); onRenameSession(session.conversation_id); }}
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-sm p-button-danger"
                        onClick={(e) => { e.stopPropagation(); onDeleteSession(session.conversation_id); }}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className="chat-session-list">
            {chatSessions.map(renderChatRow)}
        </div>
    );
};

export default ChatSessionList;
